import { Box, ButtonBase, Paper, Stack, Typography } from "@mui/material";
import { FC, MouseEvent, ReactNode } from "react";

type Props = {
	width?: number | string;
	height?: number | string;
	imageUrl?: string;
	subtitle?: string;
	title?: string;
	caption?: string | ReactNode;
	onClick?: (event: MouseEvent) => void;
};

const FeatureTile: FC<Props> = ({ width, height, imageUrl, subtitle, title, caption, onClick }) => {
	const content = (
		<Paper
			elevation={2}
			sx={{
				position: 'relative',
				width: width || 240,
				height: height || 240,
				overflow: 'hidden'
			}}
		>
			<Box
				component="img"
				src={imageUrl}
				sx={{
					width: '100%',
					height: '100%',
					borderRadius: 1,
					objectFit: 'cover',
					objectPosition: '50% 50%',
					transform: 'scale(2)',
					filter: 'brightness(0.4) blur(2px)'
				}}
			/>
			<Stack sx={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, justifyContent: 'space-between' }}>
				{imageUrl && (
					<Box
						component="img"
						src={imageUrl}
						sx={{
							flex: '1 1 auto',
							minHeight: 0,
							mt: 2,
							objectFit: 'cover',
							objectPosition: '50% 50%',
						}}
					/>
				)}
				{(caption || title) && (
					<Stack sx={{ p: 2, flex: '0 1 auto' }}>
						{subtitle && (
							<Typography variant="caption" color="textSecondary">{subtitle}</Typography>
						)}
						{title && (
							<Typography variant="h6" color="textPrimary">{title}</Typography>
						)}
						{caption && (
							<Typography variant="caption" color="textSecondary">{caption}</Typography>
						)}
					</Stack>
				)}
			</Stack>
		</Paper>
	);

	return (
		<>
			{onClick && (
				<ButtonBase
					sx={{ width: width || 240, textAlign: 'unset'}}
					onClick={onClick}
				>
					{content}
				</ButtonBase>
			)}
			{!onClick && content}
		</>
	);
};

export default FeatureTile;
